import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { channelAPI } from '../api/channel';

const CreateChannel = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [description, setDescription] = useState('');
  const [avatar, setAvatar] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!name.trim()) {
      setError('Название канала обязательно');
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login');
        return;
      }

      const payloadUsername = username.trim() ? username.trim().toLowerCase() : null;
      await channelAPI.createChannel(
        token,
        name.trim(),
        description.trim() || null,
        avatar.trim() || null,
        payloadUsername
      );

      navigate('/channels');
    } catch (err) {
      setError(err?.response?.data?.detail || err.message || 'Не удалось создать канал');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200 px-4 py-4 flex items-center gap-3">
        <button
          onClick={() => navigate('/messenger')}
          className="text-gray-600 hover:text-gray-900 text-lg"
        >
          ←
        </button>
        <h1 className="text-xl font-bold" style={{ color: '#6B5CE7' }}>
          Создать канал
        </h1>
      </div>

      <div className="max-w-xl mx-auto p-4">
        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow p-5 space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Название</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Mira News"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              maxLength={80}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Username канала</label>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value.replace('@', ''))}
              placeholder="miranews"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              maxLength={30}
            />
            <p className="mt-1 text-xs text-gray-500">Будет уникальным глобально: и среди пользователей, и среди каналов.</p>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Описание</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="О чем ваш канал"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg min-h-[90px] focus:outline-none focus:ring-2 focus:ring-purple-500"
              maxLength={400}
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Avatar URL</label>
            <input
              value={avatar}
              onChange={(e) => setAvatar(e.target.value)}
              placeholder="https://..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>

          {error ? (
            <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
              {error}
            </div>
          ) : null}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg font-semibold hover:opacity-90 transition disabled:opacity-60"
          >
            {loading ? 'Создание...' : 'Создать канал'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateChannel;
